'use es6';

import keyMirror from 'react-utils/keyMirror';
export const RequestStates = keyMirror({
  UNATTEMPTED: null,
  REQUESTING: null,
  SUCCEEDED: null,
  FAILED: null,
  FAILED_EXPIRED: null,
  FAILED_NEEDS_SUPPORT: null
});
export const requestWasAttempted = state => [RequestStates.FAILED, RequestStates.FAILED_EXPIRED, RequestStates.SUCCEEDED].indexOf(state) >= 0;
export const requestIsRequesting = state => state === RequestStates.REQUESTING;
export const requestSucceeded = state => state === RequestStates.SUCCEEDED;
export const requestFailed = state => state === RequestStates.FAILED;
export const requestFailedExpired = state => state === RequestStates.FAILED_EXPIRED;
export const requestFailedNeedsSupport = state => state === RequestStates.FAILED_NEEDS_SUPPORT;